<div>
  <input
    class="cx-counter-value js-quantity"
    #qty
    type="number"
    [min]="min"
    [max]="max"
    [step]="step"
    [formControl]="getControl() | async"
    [attr.disabled]="readonly ? 'disabled' : null"
    [class.invalid]="!isMinQty"
    (input)="handleInputChanged($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    maxlength="3"
  />
  @if (!isMinQty) {
  <mat-error> {{ 'moq.inlineMessage' | cxTranslate : { moq: moq } }}</mat-error>
  }
</div>
